import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import shoppingcart from "./shoppingcart.png";
import addtocart from "./addtocart.png";
import requisition from "./requisition.png";
import consumptionReport from "./consumptionreporticon.png";
import kitchen_1698691 from "./kitchen_1698691.png";

const MobileHome = () => {
  const [getKitchanid, setKitchanid] = useState();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchanid(user.kitchen);
    }
  }, []);

  const handleClick = (value) => {
    localStorage.setItem("selectedStore", value);
    if (value == "") {
      localStorage.setItem("KitchenType", '1');
    } else {
      localStorage.setItem("KitchenType", '0');

    }
  };


  return (
    <>
      <div class="content">
        <div class="container-fluid">
          <div class="row g-3">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">
                    <div className="col py-2">
                      <Link to="/stock" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Stock
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Stock value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={shoppingcart}
                                  alt="shoppingcart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">


                      {getKitchanid == "16" ? (
                        <Link
                          to="/ExpenditureListKitchenSub"
                          onClick={() => handleClick('')}
                          className="text-decoration-none"
                        >
                          <div className="card overflow-hidden h-100">
                            <div
                              className="bg-holder bg-card"
                              style={{
                                backgroundImage: "url(images/corner-7.png)",
                              }}
                            ></div>
                            <div className="card-body position-relative">
                              <h6 className="d-flex flex-between-center mono-card-text">
                                Sub Kitchen
                              </h6>
                              <div className="d-flex flex-between-center">
                                <div>
                                  <div
                                    className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                    id="totalState"
                                  >
                                    {/* Stock value here */}
                                  </div>
                                </div>
                                <div>
                                  <img
                                    src={shoppingcart}
                                    alt="shoppingcart"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Link
                          to="/Sub_kichen_home"
                          onClick={() => handleClick('')}
                          className="text-decoration-none"
                        >
                          <div className="card overflow-hidden h-100">
                            <div
                              className="bg-holder bg-card"
                              style={{
                                backgroundImage: "url(images/corner-7.png)",
                              }}
                            ></div>
                            <div className="card-body position-relative">
                              <h6 className="d-flex flex-between-center mono-card-text">
                                Sub Kitchen
                              </h6>
                              <div className="d-flex flex-between-center">
                                <div>
                                  <div
                                    className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                    id="totalState"
                                  >
                                    {/* Stock value here */}
                                  </div>
                                </div>
                                <div>
                                  <img
                                    src={shoppingcart}
                                    alt="shoppingcart"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      )}

                    </div>
                    <div className="col py-2">
                      <Link to="/Sub_kichen_home"
                        onClick={() => handleClick('Bandara')}
                        className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Bandara
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Stock value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={shoppingcart}
                                  alt="shoppingcart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/ExpenditureListKitchen"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Expenditure
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Expenditure value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link to="/requisition" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Requisition
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={requisition}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-3 mt-2">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">
                    <div className="col py-2">
                      <Link to="/POReport" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/11449/11449774.png"
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link to="/requisitionPO" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Purchase Order
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  // src={invoice}
                                  src="https://cdn-icons-png.flaticon.com/512/11449/11449774.png"
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link to="/expenditureListKitchen2" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Consumption Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={consumptionReport}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/PurchaseReportList"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Purchase Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={consumptionReport}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col py-2">
                      <Link
                        to="/KitchenProjectHome"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Kitchen Project
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={kitchen_1698691}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MobileHome;
